import * as React from 'react';
import { SVGProps } from 'react';
export const EnglishFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 0c3.313 0 6.313 1.344 8.484 3.516A11.962 11.962 0 0124 12c0 3.313-1.344 6.313-3.516 8.484A11.962 11.962 0 0112 24a11.962 11.962 0 01-8.484-3.516A11.962 11.962 0 010 12c0-3.313 1.344-6.313 3.516-8.484A11.962 11.962 0 0112 0zm0 0"
      fill="#999"
    />
    <path
      d="M12 .914c3.063 0 5.836 1.242 7.84 3.246l.05.055A11.053 11.053 0 0123.087 12c0 3.063-1.242 5.832-3.246 7.84l-.055.05A11.053 11.053 0 0112 23.087a11.048 11.048 0 01-7.836-3.25A11.034 11.034 0 01.914 12c0-3.063 1.242-5.836 3.246-7.84A11.063 11.063 0 0112 .914zm0 0"
      fill="#fff"
    />
    <path
      d="M12 1.855c5.602 0 10.145 4.543 10.145 10.145 0 5.602-4.543 10.145-10.145 10.145-5.602 0-10.145-4.543-10.145-10.145C1.855 6.398 6.398 1.855 12 1.855zm0 0"
      fill="#fefefe"
    />
    <path
      d="M8.602 8.418V2.441A10.157 10.157 0 003.809 6.02zm0 7.164v5.977a10.157 10.157 0 01-4.793-3.579zm6.773 0v5.984a10.14 10.14 0 004.813-3.578zm0-7.164V2.434a10.14 10.14 0 014.813 3.578zm0 0"
      fill="#012169"
    />
    <path
      d="M21.016 15.383h-2.258l2.312 1.16c.153-.3.29-.61.41-.926zm-.438-8.801l-4.055 2.031h2.258l2.293-1.148a10.239 10.239 0 00-.496-.883zM9.957 14.027v7.91a10.186 10.186 0 004.066.004v-7.914h7.918a10.196 10.196 0 00-.003-4.066h-7.915V2.059A10.073 10.073 0 0012 1.855c-.7 0-1.383.075-2.043.208V9.96H2.062a10.231 10.231 0 00-.003 4.066zm-7-5.41h2.258L2.922 7.47c-.149.3-.285.613-.406.926zm4.496 6.77H5.2l-2.277 1.14c.152.305.316.602.5.887l4.05-2.027zm0 0"
      fill="#c8102e"
    />
  </svg>
);
